import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useRegistrationStatusChartsDataContext } from './hooks/useRegistrationStatusChartsDataContext';

export const PeopleRegistered = () => {
    const { chartData } = useRegistrationStatusChartsDataContext();

    return (
        <SimpleBars
            title={'Registro de Pessoas'}
            horizontal={true}
            subtitles={chartData?.peopleRegistered?.map((item) => item.description)}
            values={chartData?.peopleRegistered?.map((item) => item.total  ||  0)}
             className='aligned-container'
        />
    );
};
